import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.webp';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1615fa18"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "layout"
};
var _hoisted_2 = {
  "class": "header"
};
var _hoisted_3 = {
  "class": "menu-panel"
};
var _hoisted_4 = {
  "class": "lang-panel"
};
var _hoisted_5 = {
  "class": "user-panel"
};
var _hoisted_6 = {
  key: 0,
  "class": "search-panel"
};
var _hoisted_7 = {
  "class": "content-panel"
};
var _hoisted_8 = {
  key: 1,
  "class": "footer-panel"
};
var _hoisted_9 = {
  key: 0,
  "class": "cookie-confirm"
};
var _hoisted_10 = {
  "class": "container"
};
var _hoisted_11 = {
  "class": "desc"
};
var _hoisted_12 = {
  "class": "cookie"
};
var _hoisted_13 = {
  "class": "btns"
};
import { onBeforeMount, ref, provide, nextTick, defineAsyncComponent } from "vue";
import { UnorderedListOutlined } from "@ant-design/icons-vue";
import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/store/global";
import { useRouter, useRoute } from "vue-router";
import { SearchOutlined } from "@ant-design/icons-vue";
import Lang from "./component/lang.vue";
import Footer from "./component/footer.vue";
import { watch } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'site',
  setup: function setup(__props) {
    var Menu = defineAsyncComponent(function () {
      return import("./component/menu.vue");
    });
    var route = useRoute();
    var keyword = ref("");
    var searchIsShow = ref(true);
    var footerIsShow = ref(true);
    var globalStore = useGlobalStore();
    var cookieConfirm = ref(0); // 1 接受, 2 不接受
    var _storeToRefs = storeToRefs(globalStore),
      pageIsLoading = _storeToRefs.pageIsLoading;
    var router = useRouter();
    var menuIsShow = ref(false);
    var onAccept = function onAccept() {
      var localStorageCookieConfirm = "1";
      localStorage.setItem("cookieConfirm", localStorageCookieConfirm);
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
    };
    var onReject = function onReject() {
      var localStorageCookieConfirm = "2";
      localStorage.setItem("cookieConfirm", localStorageCookieConfirm);
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
    };
    var showMenu = function showMenu() {
      menuIsShow.value = true;
    };
    var hideMenu = function hideMenu() {
      menuIsShow.value = false;
    };
    var isRefresh = ref(false);
    var reloadPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isRefresh.value = true;
              _context.next = 3;
              return nextTick();
            case 3:
              isRefresh.value = false;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function reloadPage() {
        return _ref.apply(this, arguments);
      };
    }();
    onBeforeMount(function () {
      var localStorageCookieConfirm = localStorage.getItem("cookieConfirm") || "0";
      cookieConfirm.value = parseInt(localStorageCookieConfirm);
      if (cookieConfirm.value === 2) {
        window.dataLayer.push(["consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied"
        }]);
      }
    });
    var toSearch = function toSearch() {
      router.push({
        name: "search"
      });
    };
    watch(function () {
      return router.currentRoute.value;
    }, function () {
      keyword.value = router.currentRoute.value.params.keyword;
      var routerName = router.currentRoute.value.name;
      if (routerName === "home" || routerName === "search" || routerName === "manufacturer-category-sku" || routerName === "category-sku") {
        searchIsShow.value = false;
      } else {
        searchIsShow.value = true;
      }
      if (routerName === "search") {
        // footerIsShow.value = false;
      }
    }, {
      immediate: true,
      deep: true
    });
    var toHome = function toHome() {
      router.push({
        name: "home"
      });
    };
    provide("reloadPage", reloadPage);
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_router_view = _resolveComponent("router-view");
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!menuIsShow.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "icon",
        onClick: _withModifiers(showMenu, ["stop"])
      }, [_createVNode(_unref(UnorderedListOutlined))])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": "icon active",
        onClick: _withModifiers(hideMenu, ["stop"])
      }, [_createVNode(_unref(UnorderedListOutlined))]))]), _createElementVNode("div", {
        "class": "logo-panel"
      }, [_createElementVNode("img", {
        onClick: toHome,
        "class": "logo",
        src: _imports_0,
        alt: "aichiplink logo"
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(Lang)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
        "class": "icon",
        to: {
          name: 'rfq'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("RFQ")];
        }),
        _: 1
      })])]), searchIsShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        "class": "search",
        onClick: toSearch
      }, [keyword.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(keyword.value), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_unref(SearchOutlined)), _createTextVNode(" " + _toDisplayString(_ctx.$t("Input keywords / Part number")), 1)], 64))])])) : _createCommentVNode("", true), _createVNode(_unref(Menu), {
        value: menuIsShow.value,
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return menuIsShow.value = $event;
        })
      }, null, 8, ["value"]), _createElementVNode("div", _hoisted_7, [!isRefresh.value ? (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(route).path
      })) : _createCommentVNode("", true)]), !_unref(pageIsLoading) && footerIsShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(Footer)])) : _createCommentVNode("", true)]), cookieConfirm.value == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode(_toDisplayString(_ctx.$t("We use cookies to give you the best possible experience with aichiplink.com. Some are essential for this site to function; others help us understand how you use the site, so we can improve it. We may also use cookies for targeting purposes.")) + " ", 1), _createVNode(_component_router_link, {
        to: {
          name: 'cookie-policy'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("Cookie Notice")), 1)];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: onAccept,
        "class": "btn accept"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Accept")), 1)];
        }),
        _: 1
      }), _createVNode(_component_a_button, {
        "class": "btn",
        onClick: onReject
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Reject")), 1)];
        }),
        _: 1
      })])])])) : _createCommentVNode("", true)], 64);
    };
  }
});